import React from "react";
import {
  InclusionContent,
  Icon,
  TextStyle
} from "@silversea-ssc/ui-components-react";
import { BlockContent } from "components/BlockContent";
import type { TokenValues } from "@silversea-ssc/dotcom-read-model-types/Tokens";
import * as styles from "./InclusionsModalTabContent.module.scss";

type Props = {
  content: InclusionContent;
  tokens: TokenValues | undefined;
};

const InclusionsModalTabContent: React.FC<Props> = ({ content, tokens }) => {
  return (
    <div key={content._id} className={styles.wrapper}>
      <Icon
        name={content.icon}
        size="2x"
        wrapperClassName={styles.icon}
        padding={false}
      />
      <div className={styles.title}>
        <BlockContent value={content.title} tokens={tokens} />
      </div>
      <TextStyle fontSize="inherit" className={styles.content}>
        <BlockContent value={content.description} tokens={tokens} />
      </TextStyle>
    </div>
  );
};

export default InclusionsModalTabContent;
